"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_image_lightbox_1 = tslib_1.__importDefault(require("react-image-lightbox"));
var mobx_1 = require("mobx");
var map_1 = tslib_1.__importDefault(require("lodash/map"));
var RouterComponents_1 = require("./RouterComponents");
var ClaimForm_1 = require("./ClaimForm");
var Breadcrumbs_1 = require("./Breadcrumbs");
var routes_1 = require("../../routes");
var utils_1 = require("../utils");
var ProductPage = /** @class */ (function (_super) {
    tslib_1.__extends(ProductPage, _super);
    function ProductPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLightboxOpen = false;
        _this.photoIndex = 0;
        return _this;
    }
    ProductPage.prototype.render = function () {
        var _this = this;
        var product = this.props.store.data.product;
        if (!product) {
            return react_1.default.createElement(RouterComponents_1.NotFoundPage, null);
        }
        var images = product.images;
        return (react_1.default.createElement("div", { className: "partner" },
            this.isLightboxOpen && (react_1.default.createElement(react_image_lightbox_1.default, { mainSrc: images[this.photoIndex].url, nextSrc: images.length > 1
                    ? images[(this.photoIndex + 1) % images.length].url
                    : undefined, prevSrc: images.length > 1
                    ? images[(this.photoIndex + images.length - 1) % images.length].url
                    : undefined, onMovePrevRequest: function () {
                    return (_this.photoIndex =
                        (_this.photoIndex + images.length - 1) % images.length);
                }, onMoveNextRequest: function () {
                    return (_this.photoIndex = (_this.photoIndex + 1) % images.length);
                }, onCloseRequest: function () { return (_this.isLightboxOpen = false); } })),
            react_1.default.createElement(RouterComponents_1.Meta, { meta: {
                    title: product.title + ", \u043A\u0443\u043F\u0438\u0442\u044C, \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430, \u043C\u043E\u043D\u0442\u0430\u0436 | \u0410\u043B\u0430\u043A\u0430\u0442\u0442\u043E",
                    description: utils_1.shortenString(utils_1.stripHtml(product.description), 160),
                    keywords: ['купить', 'заказать', 'монтаж']
                        .map(function (x) { return x + " " + product.preview_title; })
                        .join(', '),
                } }),
            react_1.default.createElement("div", { className: "section section_less-padding" },
                react_1.default.createElement("div", { className: "wrapper wrapper_big" },
                    react_1.default.createElement(Breadcrumbs_1.Breadcrumbs, { items: [
                            {
                                name: 'Главная',
                                href: '/',
                            },
                            {
                                name: product.company.name,
                                href: routes_1.Routes.partners + "/" + product.company.slug,
                            },
                            {
                                name: product.category.name,
                                href: routes_1.Routes.catalog + "/" + product.category.slug,
                            },
                            {
                                name: product.preview_title,
                            },
                        ] }),
                    react_1.default.createElement("h2", { className: "text-header text-header_h2 text-header_first" }, product.title),
                    product.description && react_1.default.createElement(HtmlBlock, { text: product.description }),
                    react_1.default.createElement("div", { className: "product__row" },
                        react_1.default.createElement("div", { className: "product__row-item" },
                            product.specification && (react_1.default.createElement("div", null,
                                react_1.default.createElement("h3", null, "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438"),
                                react_1.default.createElement(HtmlBlock, { text: product.specification }))),
                            product.specification ? (react_1.default.createElement(Documentation, { product: product })) : (react_1.default.createElement(Photos, { product: product, onClick: mobx_1.action(function (index) {
                                    _this.isLightboxOpen = true;
                                    _this.photoIndex = index;
                                }) }))),
                        react_1.default.createElement("div", { className: "product__row-item" }, product.specification ? (react_1.default.createElement(Photos, { product: product, onClick: mobx_1.action(function (index) {
                                _this.isLightboxOpen = true;
                                _this.photoIndex = index;
                            }) })) : (react_1.default.createElement(Documentation, { product: product })))))),
            react_1.default.createElement(ClaimForm_1.ClaimFormSection, null)));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], ProductPage.prototype, "isLightboxOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProductPage.prototype, "photoIndex", void 0);
    ProductPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ProductPage);
    return ProductPage;
}(react_1.default.Component));
exports.ProductPage = ProductPage;
var HtmlBlock = function (_a) {
    var text = _a.text;
    var _b = react_1.useState([]), images = _b[0], setImages = _b[1];
    var _c = react_1.useState(null), photoIndex = _c[0], setPhotoIndex = _c[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "html-block fr-view", dangerouslySetInnerHTML: { __html: text }, onClick: function (e) {
                var target = e.target;
                if ((target === null || target === void 0 ? void 0 : target.tagName) === 'IMG') {
                    var allImgElements = e.currentTarget.querySelectorAll('img');
                    var imageUrls = map_1.default(allImgElements, function (element) {
                        return element.getAttribute('src');
                    }).filter(Boolean);
                    setImages(imageUrls);
                    setPhotoIndex(imageUrls.indexOf(target.getAttribute('src')));
                }
            } }),
        images.length > 0 && (react_1.default.createElement(react_image_lightbox_1.default, { mainSrc: images[photoIndex], nextSrc: images.length > 1 ? images[(photoIndex + 1) % images.length] : undefined, prevSrc: images.length > 1
                ? images[(photoIndex + images.length - 1) % images.length]
                : undefined, onMovePrevRequest: function () {
                return setPhotoIndex((photoIndex + images.length - 1) % images.length);
            }, onMoveNextRequest: function () { return setPhotoIndex((photoIndex + 1) % images.length); }, onCloseRequest: function () { return setImages([]); } }))));
};
var Documentation = function (_a) {
    var product = _a.product;
    var _b;
    if (((_b = product.files) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return null;
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F"),
        react_1.default.createElement("div", { className: "product__docs" }, product.files.map(function (file) { return (react_1.default.createElement("div", { key: file.id, className: "product__docs-item" },
            react_1.default.createElement("a", { target: "_blank", href: file.url },
                file.alternativeText,
                " (",
                file.ext,
                ", ",
                (file.size / 1024).toFixed(2),
                " \u041C\u0411)"))); }))));
};
var Photos = function (_a) {
    var product = _a.product, onClick = _a.onClick;
    var _b;
    if (((_b = product.images) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return null;
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", null, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438"),
        react_1.default.createElement("div", { className: "image-grid" }, product.images.map(function (image, index) {
            var _a, _b;
            return (react_1.default.createElement("div", { key: image.id, onClick: function () { return onClick(index); } },
                react_1.default.createElement("img", { src: ((_b = (_a = image.formats) === null || _a === void 0 ? void 0 : _a.small) === null || _b === void 0 ? void 0 : _b.url) || image.url })));
        }))));
};
